module.exports = __webpack_public_path__ + "static/img/longshen.b6e7b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/longshen.jpg
// module id = PIUa
// module chunks = 0